export default function reducer(state = {
  open: 'closed',
  z: 1,
  w: 0,
  h: 0,
  x: 0,
  y: 0,
}, action = {}) {
  switch (action.type) {
    case 'CALCULATE_SHOP':
      return {
        ...state,
        x: action.x,
        y: action.y,
        w: action.w,
        h: action.h,
        open: action.open,
      };
    case 'RECALCULATE_SHOP_ON_MOBILE':
      return {
        ...state,
        x: action.x,
        y: action.y,
        w: action.w,
        h: action.h,
      };
    case 'OPEN_SHOP':
      return {
        ...state,
        open: 'open',
        z: action.z,
      };
    case 'CLOSE_SHOP':
      return {
        ...state,
        open: 'closed',
      };
    case 'BRING_SHOP_TO_FRONT':
      return {
        ...state,
        z: action.z,
        open: 'open',
      };
    default:
      return state;
  }
}

export const calculateShop = (params) => {
  const { isMobile, windowHeight, windowWidth, landedSlug, mobileOrientation, } = params;
  if (isMobile) {
    return {
      type: 'CALCULATE_SHOP',
      x: 0,
      y: 0,
      w: mobileOrientation === 'landscape' ? windowWidth - 150 : windowWidth,
      h: mobileOrientation === 'landscape' ? windowHeight : windowHeight - 150,
      open: 'closed',
    };
  }
  const width = 400;
  const height = 250;
  return {
    type: 'CALCULATE_SHOP',
    x: 475,
    y: 50,
    w: width,
    h: height,
    open: (!landedSlug) ? 'open' : 'closed',
  };
};

export const recalculateShopOnMobile = (params) => {
  const { windowWidth, windowHeight, mobileOrientation, } = params;
  return {
    type: 'RECALCULATE_SHOP_ON_MOBILE',
    x: 0,
    y: 0,
    w: mobileOrientation === 'landscape' ? windowWidth - 150 : windowWidth,
    h: mobileOrientation === 'landscape' ? windowHeight : windowHeight - 150,
  };
};

export const openShop = (z) => {
  return {
    type: 'OPEN_SHOP',
    z,
  };
};

export const closeShop = (e) => {
  // stop propagation here to prevent handleBringToFront from getting called
  if (e && e.target) {
    e.stopPropagation();
  }
  return {
    type: 'CLOSE_SHOP',
  };
};

export const bringShopToFront = (z) => {
  return {
    type: 'BRING_SHOP_TO_FRONT',
    z,
  };
};
